var _rect, _path, _path2, _path3, _path4, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFocusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.875,
    y: 4.5,
    width: 19,
    height: 17,
    rx: 4.5,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.375 14C8.375 13.7239 8.15114 13.5 7.875 13.5C7.59886 13.5 7.375 13.7239 7.375 14H8.375ZM7.375 17C7.375 17.2761 7.59886 17.5 7.875 17.5C8.15114 17.5 8.375 17.2761 8.375 17H7.375ZM6.375 15C6.09886 15 5.875 15.2239 5.875 15.5C5.875 15.7761 6.09886 16 6.375 16V15ZM9.375 16C9.65114 16 9.875 15.7761 9.875 15.5C9.875 15.2239 9.65114 15 9.375 15V16ZM7.375 14V15.5H8.375V14H7.375ZM7.375 15.5V17H8.375V15.5H7.375ZM7.875 15H6.375V16H7.875V15ZM6.375 16H9.375V15H6.375V16Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8725 11.465C6.6825 11.465 6.4925 11.395 6.3425 11.245L5.5925 10.495C5.3025 10.205 5.3025 9.89426 5.5925 9.60426C5.8825 9.31426 6.085 9.42749 6.375 9.71749L6.875 10.2175L8.875 8.21751C9.165 7.92751 9.3625 7.9275 9.6525 8.2175C9.94253 8.5075 9.94253 8.70499 9.6525 8.99499L7.4025 11.245C7.2625 11.385 7.0725 11.465 6.8725 11.465Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 10H18.375",
    stroke: "black",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 15.5H18.375",
    stroke: "black",
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.875,
    y: 0.5,
    width: 7,
    height: 2,
    rx: 1,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusIcon);
export default __webpack_public_path__ + "static/media/focus_icon.0f2ff3cd17497a4118273c04cb7f7380.svg";
export { ForwardRef as ReactComponent };